// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery.simple-collapse';
import { dispatchEvent } from '../src/lib/dom';

export default class SimpleCollapse extends WebComponent {
  enterDocument() {
    const {
      type,
    } = this.props;

    $(this.element.parentElement).simpleCollapse({
      selector: `#${this.element.getAttribute('id')}`,
      type: type || 'href',
      onAfterOpen: () => {
        dispatchEvent(window, 'resize');
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/SimpleCollapse.js